import actionTypes from './actionTypes'

const mediaSearchActions = {

	search(params, resolve, reject) {
		return {
			type: actionTypes.MEDIA_SEARCH_GET_RESULTS,
			value: params.value,
			page: params.page,
			searchType: params.searchType,
			allowSearchMore: params.allowSearchMore,
			source: params.source,
			resolve,
			reject,
		}
	},

}

export default mediaSearchActions
